if (!customElements.get('woofly-header')) {
  customElements.define('woofly-header', class WooflyHeader extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.dialog = this.querySelector('[data-wf-menu-dialog]');
      this.opener = this.querySelector('[data-wf-menu-open]');
      if (!this.dialog || !this.opener) return;

      const options = { signal: this.controller.signal };
      const mega = this.querySelector('[data-wf-mega]');
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && mega?.open) {
          mega.open = false;
          mega.querySelector('summary')?.focus();
        }
      }, options);
      document.addEventListener('click', (event) => {
        if (mega?.open && !mega.contains(event.target)) mega.open = false;
      }, options);
      this.addEventListener('focusout', (event) => {
        if (mega?.open && event.relatedTarget && !mega.contains(event.relatedTarget)) mega.open = false;
      }, options);
      this.opener.addEventListener('click', () => {
        if (this.dialog.open) return;
        this.dialog.showModal();
        this.opener.setAttribute('aria-expanded', 'true');
      }, options);

      this.querySelector('[data-wf-menu-close]')?.addEventListener('click', () => this.closeMenu(), options);
      this.dialog.addEventListener('close', () => {
        this.opener.setAttribute('aria-expanded', 'false');
        if (this.opener.getClientRects().length) this.opener.focus({ preventScroll: true });
      }, options);

      // Native modal-dialog behavior supplies focus containment, page inertness,
      // and Escape handling. Links close the drawer before following their URL.
      this.dialog.addEventListener('click', (event) => {
        if (event.target.closest('a[href]')) this.closeMenu();
      }, options);

      this.desktop = window.matchMedia('(min-width: 990px)');
      this.onViewportChange = () => {
        if (this.desktop.matches) this.closeMenu();
      };
      this.desktop.addEventListener('change', this.onViewportChange);

      // Restore editor selection context when navigation blocks are selected.
      document.addEventListener('shopify:block:select', (event) => {
        if (!this.desktop.matches && this.contains(event.target) && !this.dialog.open) {
          this.dialog.showModal();
          this.opener.setAttribute('aria-expanded', 'true');
        }
      }, options);
    }

    closeMenu() {
      if (this.dialog?.open) this.dialog.close();
    }

    disconnectedCallback() {
      this.closeMenu();
      this.controller?.abort();
      this.desktop?.removeEventListener('change', this.onViewportChange);
    }
  });
}
